/* eslint-disable react-hooks/rules-of-hooks */

import React from 'react'
import useHandlerDebounced from './useHandlerDebounced'

/**
 * Execute an effect when dependencies stop updating (debounced)
 * @param {Function} effect - the effect function
 * @param {Array} deps - the dependencies array
 * @param {Number} timeout - number of milliseconds used to debounce
 * @param {Object} options - options for the lodash debounce method
 */
const useEffectDebounced = (timeout, options) => (effect, deps) => {
  // debounce effect
  const debounced = useHandlerDebounced(timeout, options)(effect)
  // useEffect with debounced effect
  React.useEffect(debounced, deps)
}

export default useEffectDebounced
